import type { CSSProperties, JSX } from 'react'

import type { Icon } from '.'

export function Search({ className, style }: Readonly<Icon>): JSX.Element {
  const styles: CSSProperties = {
    fill: 'none',
    stroke: '#000',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    strokeWidth: 45.67,
    ...style,
  }

  return (
    <svg
      className={className}
      data-name="Layer 1"
      id="Layer_1"
      viewBox="0 0 3000 3000"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m484.03,1274.23c0,436.42,353.79,790.2,790.2,790.2s790.2-353.79,790.2-790.2-353.79-790.2-790.2-790.2-790.2,353.79-790.2,790.2"
        style={styles}
      />
      <path d="m2515.97,2515.97l-677.32-677.32" style={styles} />
    </svg>
  )
}

export default Search
